export default __webpack_public_path__ + "static/media/_plus-circle_blue.44cdd102.svg";